import { createAction } from '@reduxjs/toolkit'

export const setRestrictedUserNames = createAction<string[]>('global/setRestrictedUserNames')

export const setMprolabContractsLastModifiedDate = createAction<Date>('global/setMprolabContractsLastModifiedDate')

export const setLifetimeTokens = createAction<{ account: string; accessToken: string }>('global/setLifetimeTokens')

/**
 * Drop a session token the server has declared dead, so the app falls back to
 * signed-out and offers the normal sign-in instead of polling with it forever.
 */
export const clearLifetimeToken = createAction<{ account: string }>('global/clearLifetimeToken')

export const setRestrictedNamesLastModifiedDate = createAction<Date>('global/setRestrictedNamesLastModifiedDate')

export default createAction
